import { makeSimpleMapper } from "@/core/acl/mapperFactory";
import { zRouteSchemaDom } from "@/types/route/route.domain";
import { zRouteSchemaDto } from "@/types/route/route.dto";
/**
 * Маппер для Route: DTO <-> Domain (1:1).
 */
export const RouteMapper = makeSimpleMapper({
    dtoToDomain: (dto) => zRouteSchemaDom.parse(dto),
    domainToDto: (domain) => zRouteSchemaDto.parse(domain),
    dtoToCreateDto: (domain) => zRouteSchemaDto.omit({ id: true }).parse(domain),
    dtoToCreateDom: (dto) => zRouteSchemaDom.omit({ id: true }).parse(dto),
});
